import { render } from "./ProjectMarker.vue?vue&type=template&id=0cd95db2"
import script from "./ProjectMarker.vue?vue&type=script&lang=js"
export * from "./ProjectMarker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__